import { bookingMessageAtom } from 'components/forms/bookingWidget/jotaiStore';
import { MessageError, SimplifiedRHFErrors } from 'components/forms/bookingWidget/shared';
import { useMessageOwnerTracking } from 'components/pdp/v3/events/message-owner-events';
import { FlexCol } from 'components/primitives/flex';
import Textarea from 'components/ui/Textarea/Textarea';
import { valueEmpty } from 'helpers';
import { useAtom } from 'jotai';
import { MutableRefObject } from 'react';
import type { UseFormMethods } from 'react-hook-form';

interface ErrorWithMessage extends SimplifiedRHFErrors {
  message?: {
    message: string;
  };
}

interface TextInputProps {
  messageOwnerWrapperRef: MutableRefObject<undefined>;
  errors: ErrorWithMessage;
  register: UseFormMethods['register'];
  watch: UseFormMethods['watch'];
}
export default ({ messageOwnerWrapperRef, errors, register, watch }: TextInputProps) => {
  const [, setBookingMessage] = useAtom(bookingMessageAtom);
  const { trackClickTextBox } = useMessageOwnerTracking();

  return (
    <FlexCol data-testid="textarea-wrapper" ref={messageOwnerWrapperRef}>
      <Textarea
        onClick={trackClickTextBox}
        onChange={(e) => {
          setBookingMessage(e.target.value);
        }}
        hasError={Boolean(errors.message?.message)}
        style={{ minHeight: '150px', resize: 'none' }}
        inputRef={register({
          required: 'Please enter your message',
        })}
        hasValue={!valueEmpty(watch('message'))}
        name="message"
        placeholder="Tell the owner about your trip and boating experience..."
        label="Your message"
      />
      <MessageError>{errors.message?.message}</MessageError>
    </FlexCol>
  );
};
